// export const config = {
//     app: {
//         BASE_URL: "http://localhost:3020",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/conn",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//         maxsizefile: 200,
//         maxsizefileoption: 0.2, // 200 KB
//     },
//     secure: {
//         BASE_URL: "http://localhost:3020",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/security",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//     },
//     domain: {
//         BASE_URL: "http://localhost:3020",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/domains",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//     },
//     api: {
//         BASE_URL: "http://192.168.230.5:3020",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/apis",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//     },
//     socket: {
//         BASE_URL: "ws://localhost:4000",
//         PORT: 4000,
//     },
//     texts: {
//         unavailblemsg: "Service unavailable! Try again later.",
//         failmsg: "Operation fail! Try again later.",
//         sessionexpmsg: "Your session has expired.",
//     },
//     mailfrom: "service@yconnekt.com",
//     campay: {
//         urlToCampay: "https://www.campay.net",
//         campayuser: "1_zgFRZczH09yCdnBLLHZPTHsHh89D0YQVZEeVmmc4QDBhkgZcC6lLFXDGrf1MrkhgJGgVUNyWWdGlib0kF83w",
//         campaypass: "Y-kHHJOPkxXhY3fR84nDH6GzGl88epCkrD1g2jouKD_NmmO8cz4fMsCVDWp0PHEE8TDn8RZwyspt8saZx7E7CA",
//     },
// }

// export const config = {
//     app: {
//         BASE_URL: "http://192.168.43.5:3020",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/conn",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//         maxsizefile: 200,
//         maxsizefileoption: 0.2, // 200 KB
//     },
//     secure: {
//         BASE_URL: "http://192.168.43.5:3020",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/security",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//     },
//     domain: {
//         BASE_URL: "http://192.168.43.5:3020",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/domains",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//     },
//     api: {
//         BASE_URL: "http://192.168.43.5:3020",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/apis",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//     },
//     socket: {
//         BASE_URL: "ws://192.168.43.5:4000",
//         PORT: 4000,
//     },
//     texts: {
//         unavailblemsg: "Service unavailable! Try again later.",
//         failmsg: "Operation fail! Try again later.",
//         sessionexpmsg: "Your session has expired.",
//     },
//     mailfrom: "service@yconnekt.com",
//     campay: {
//         urlToCampay: "https://www.campay.net",
//         campayuser: "1_zgFRZczH09yCdnBLLHZPTHsHh89D0YQVZEeVmmc4QDBhkgZcC6lLFXDGrf1MrkhgJGgVUNyWWdGlib0kF83w",
//         campaypass: "Y-kHHJOPkxXhY3fR84nDH6GzGl88epCkrD1g2jouKD_NmmO8cz4fMsCVDWp0PHEE8TDn8RZwyspt8saZx7E7CA",
//     },
// }

// export const config = {
//     app: {
//         BASE_URL: "https://yconapi.yconnekt.cm",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/conn",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//         maxsizefile: 200,
//         maxsizefileoption: 0.2, // 200 KB
//     },
//     secure: {
//         BASE_URL: "https://yconapi.yconnekt.cm",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/security",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//     },
//     domain: {
//         BASE_URL: "https://yconapi.yconnekt.cm",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/domains",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//     },
//     api: {
//         BASE_URL: "https://yconapi.yconnekt.cm",
//         PORT: 3020,
//         PROJECT: "yconnekt/v1/apis",
//         PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
//         limit5: 5,
//         limit: 10,
//         limit50: 50,
//         limit100: 100,
//     },
//     socket: {
//         BASE_URL: "wss://yconapi.yconnekt.cm",
//         PORT: 4000,
//     },
//     texts: {
//         unavailblemsg: "Service unavailable! Try again later.",
//         failmsg: "Operation fail! Try again later.",
//         sessionexpmsg: "Your session has expired.",
//     },
//     mailfrom: "service@yconnekt.com",
//     campay: {
//         urlToCampay: "https://www.campay.net",
//         campayuser: "1_zgFRZczH09yCdnBLLHZPTHsHh89D0YQVZEeVmmc4QDBhkgZcC6lLFXDGrf1MrkhgJGgVUNyWWdGlib0kF83w",
//         campaypass: "Y-kHHJOPkxXhY3fR84nDH6GzGl88epCkrD1g2jouKD_NmmO8cz4fMsCVDWp0PHEE8TDn8RZwyspt8saZx7E7CA",
//     },
// }


export const config = {
    app: {
        BASE_URL: "https://yconapi.yconnekt.com",
        PORT: 3020,
        PROJECT: "yconnekt/v1/conn",
        PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
        limit5: 5,
        limit: 10,
        limit50: 50,
        limit100: 100,
        maxsizefile: 200,
        maxsizefileoption: 0.2, // 200 KB
    },
    secure: {
        BASE_URL: "https://yconapi.yconnekt.com",
        PORT: 3020,
        PROJECT: "yconnekt/v1/security",
        PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
        limit5: 5,
        limit: 10,
        limit50: 50,
        limit100: 100,
    },
    domain: {
        BASE_URL: "https://yconapi.yconnekt.com",
        PORT: 3020,
        PROJECT: "yconnekt/v1/domains",
        PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
        limit5: 5,
        limit: 10,
        limit50: 50,
        limit100: 100,
    },
    api: {
        BASE_URL: "https://yconapi.yconnekt.com",
        PORT: 3020,
        PROJECT: "yconnekt/v1/apis",
        PUBLICKEY: "b4b6dafe34d5d5af67a8a5def4bbac85",
        limit5: 5,
        limit: 10,
        limit50: 50,
        limit100: 100,
    },
    socket: {
        BASE_URL: "wss://yconapi.yconnekt.com",
        PORT: 4000,
    },
    texts: {
        unavailblemsg: "Service unavailable! Try again later.",
        failmsg: "Operation fail! Try again later.",
        sessionexpmsg: "Your session has expired.",
    },
    mailfrom: "service@yconnekt.com",
    campay: {
        urlToCampay: "https://www.campay.net",
        campayuser: "1_zgFRZczH09yCdnBLLHZPTHsHh89D0YQVZEeVmmc4QDBhkgZcC6lLFXDGrf1MrkhgJGgVUNyWWdGlib0kF83w",
        campaypass: "Y-kHHJOPkxXhY3fR84nDH6GzGl88epCkrD1g2jouKD_NmmO8cz4fMsCVDWp0PHEE8TDn8RZwyspt8saZx7E7CA",
    },
}